/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CreateGreenhouseJobsAsync$Params {
  companyGuid: string;
      body?: Array<string>
}

export function createGreenhouseJobsAsync(http: HttpClient, rootUrl: string, params: CreateGreenhouseJobsAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createGreenhouseJobsAsync.PATH, 'post');
  if (params) {
    rb.path('companyGuid', params.companyGuid, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createGreenhouseJobsAsync.PATH = '/integrations/greenhouse/companies/{companyGuid}/jobs';
